import * as React from 'react'

import { HeaderContainer } from '@user/components/DetailPages/HeaderContainer'
import type { ILeadDetail } from '@user/store/lead/typings'
import { useGetAllFunnelStagesOnMount } from '@user/store/salesFunnel/hooks'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { LeadParentHeader } from '@user/features/EntityDetails/components/LeadParentHeader'

interface Props {
  detail: ILeadDetail
  canUpdate: boolean
  canDelete: boolean
  canConvert: boolean
}

export function ActionsHeader(props: Props) {
  const { detail } = props
  const funnelStageStatus = useGetAllFunnelStagesOnMount()

  return (
    <HeaderContainer paddingY="8px">
      {funnelStageStatus == 'fail' && (
        <Alert severity="error"> Failed to load Sales Funnel stages.</Alert>
      )}

      {funnelStageStatus == 'pending' && <CircularProgress />}

      {funnelStageStatus == 'success' && (
        <Box width="100%">
          <LeadParentHeader detailPage lead={detail} {...props} />
        </Box>
      )}
    </HeaderContainer>
  )
}
